import { Box, Drawer, Hidden, Paper } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { IconButton } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import SideNav, { NavIcon, NavItem, NavText } from "@trendmicro/react-sidenav";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import clsx from "clsx";
import jwt_decode from "jwt-decode";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PerfectScrollbar from "react-perfect-scrollbar";
import { connect, useDispatch } from "react-redux";
import { Route, BrowserRouter as Router, useHistory } from "react-router-dom";
import EmergencyDoorIcon from "../../../src/assets/USA_Images/dashboard_icons/EmergencyDoorIcon.svg";
import "../../assets/layout-components/Sidebar/custom_sidebar.css";
import EmergencyDoor from "../../components/DialogBoxComponent/EmergencyDoor";
import PinDialogBox from "../../components/DialogBoxComponent/PinDialogBox";
import { setSidebarToggleMobile } from "../../reducers/ThemeOptions";
import {
  customerSubscription,
  listPaymentMethods,
} from "../../slices/Subscription/SubscriptionSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import SidebarHeader from "../SidebarHeader";
import navItemCustomer from "./navItemCustomer";
import navItemDealer from "./navItemDealer";
import navItemEmployeelogin from "./navItemEmployeelogin";
import navItemFrontEnd from "./navItemFrontEnd";
import navItemUSA from "./navItemUSA";
import navItems from "./navItems";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import EmergencyDoorIconDark from "../../../src/assets/USA_Images/dashboard_icons/EmergenceDoorDark.svg";
import EmergencyDoorIconHoverDark from "../../../src/assets/EmergencyDoorIconHover.svg";
import EmergencyDoorWhiteHover from "../../../src/assets/USA_Images/EmergencyDoorWhiteHover.svg";
import CollapsIcon from "../../assets/images/dashboard-icons/ArrowLeftSideBarCloseIcon";
import ExpandArrowIcon from "../../assets/images/dashboard-icons/ArrowLeftSideBarOpenIcon";
import CheckInPin from "../../../src/assets/USA_Images/dashboard_icons/CheckInPin.svg";
import CheckInPinDark from "../../../src/assets/USA_Images/dashboard_icons/CheckInWithPinDark.svg";
import CheckInPinDarkHover from "../../../src/assets/USA_Images/dashboard_icons/CheckinWithPinDarkHover.svg";
import CheckInPinWhiteHover from "../../../src/assets/USA_Images/dashboard_icons/CheckInPinHoverWhite.svg";

function Sidebar({
  setSidebarToggleMobile,
  sidebarToggleMobile,
  sidebarShadow,
  ...props
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const closeDrawer = () => setSidebarToggleMobile(!sidebarToggleMobile);
  const [expand, setExpand] = useState(true);
  const [active, setActive] = React.useState("none");
  const [activeMenu, setActiveMenu] = React.useState("none");
  const [toggle, setToggle] = useState(true);
  const [open, setOpen] = useState(false);
  const [openDoor, setOpenDoor] = useState(false);
  const [position, setPosition] = useState(24);
  const [doorPosition, setDoorPosition] = useState(17);
  const [bottom, setBottom] = useState(3.5);
  const [doorBottom, setDoorBottom] = useState(3.5);
  const { t } = useTranslation();
  const [hoveredItem, setHoveredItem] = useState(null);
  const [hovered, setHovered] = useState(false);
  const [hoveredPin, setHoveredPin] = useState(false);
  const [filterData, setFilterData] = useState([navItemUSA]);
  var perfectSideBar;
  const features = [
    "Walk-In Registration",
    "Offender",
    "Checklist",
    "Watchlist",
    "Card Template",
    "Atlas Integration",
  ];
  const [featureList, setFeatureList] = useState([]);
  const [paymentmethod, setPaymentmethod] = useState(false);
  const { darkMode, diaLogBoxBlur } = useContext(ThemeContext);
  const [expandedParents, setExpandedParents] = useState({});
  const [expandedParent, setExpandedParent] = useState(null);
  const toggleIcon = (parent) => {
    if (!parent.items) {
      history.push({
        pathname: parent.link,
      });
    } else {
      setIcon(!icon);
    }
  };

  const toggleExpansion = (parentName) => {
    setExpandedParent((prevState) =>
      prevState === parentName ? null : parentName
    );
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleOpenDoor = () => {
    setOpenDoor(true);
  };
  const [activeParent, setActiveParent] = useState(null);

  const handlenav = (child, parent) => {
    setActiveParent(parent.name);
    history.push({
      pathname: child.link,
    });
  };

  const getImage = () => {
    if (darkMode)
      return hovered ? EmergencyDoorIconHoverDark : EmergencyDoorIconDark;
    return hovered ? EmergencyDoorWhiteHover : EmergencyDoorIcon;
  };

  const getPinImage = () => {
    if (darkMode) return hoveredPin ? CheckInPinDarkHover : CheckInPinDark;
    return hoveredPin ? CheckInPinWhiteHover : CheckInPin;
  };

  useEffect(() => {
    if (localStorage.getItem("companyType") === "PARTNER") {
      dispatch(listPaymentMethods(localStorage.getItem("companyId")))
        .unwrap()
        .then((data) => {
          setPaymentmethod(!data ? true : false);
        })
        .catch((er) => {});
    }
  }, []);

  useEffect(() => {
    let payload = {
      companyId: decoded_jwtToken.companyId,
    };
    if (decoded_jwtToken.companyType === "CUSTOMER") {
      perfectSideBar = dispatch(customerSubscription(payload))
        .unwrap()
        .then((res) => {
          if (res.code === "MSGS4032" && res.data) {
            const featureNames = res.data.data.feature.map(
              (feature) => feature.name
            );
            setFeatureList(featureNames);
          }
        });
    }
  }, []);

  useEffect(() => {
    if (decoded_jwtToken.companyType === "CUSTOMER") {
      const normalizedFeatureList = featureList.map((feature) => {
        if (feature === "Checklist") {
          return "Checklist";
        }
        if (feature === "Watchlist") {
          return "Watchlist";
        }
        if (feature === "Offender Verification") {
          return "Offender";
        }
        if (
          feature ===
          "Walk-In Registration through DL & Passport Scanner on Web"
        ) {
          return "Walk-In Registration";
        }
        return feature;
      });
      if (normalizedFeatureList.length !== 0) {
        const filteredData = navItemUSA
          .map((item) => {
            if (
              item.name === "Offender" &&
              !normalizedFeatureList.includes("Offender")
            ) {
              return null;
            }
            if (item.items) {
              const filteredItems = item.items.filter((subItem) => {
                if (
                  subItem.name === "Offender" ||
                  subItem.name === "Delivery Report" ||
                  subItem.name === "Checklist" ||
                  subItem.name === "Watchlist" ||
                  subItem.name === "Card Template" ||
                  subItem.name === "Atlas Integration"
                ) {
                  return normalizedFeatureList.includes(subItem.name);
                } else {
                  return true;
                }
              });
              return { ...item, items: filteredItems };
            }
            return item;
          })
          .filter(Boolean);
        setFilterData(filteredData);
      } else {
        setFilterData(navItemUSA);
      }
    }
  }, [featureList]);

  const handleToggle = () => {
    setToggle(!toggle);
    if (!toggle) {
      setExpand(true);
    } else {
      setExpand(false);
      setBottom(120);
      setDoorBottom(60);
      setPosition(2.75);
      setDoorPosition(4);
    }
    if (expand === true) {
      setExpand(false);

      props.onchange(false);
    } else {
      setExpand(true);
      setBottom(0);
      setDoorBottom(0);
      setPosition(24);
      setDoorPosition(17);
      props.onchange(true);
    }
  };

  const onClickMenu = () => {
    if (expand === true) {
      setExpand(false);
      props.onchange(false);
    } else {
      setExpand(true);
      props.onchange(true);
    }
  };
  const [userType, setUserType] = useState("");

  useEffect(() => {
    setUserType(localStorage.getItem("companyType"));
  }, []);

  const zlink = localStorage.getItem("redirectFrom");

  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN)
  );

  const [icon, setIcon] = React.useState(false);

  const isActiveMenu = (items) => {
    if (items instanceof Array) {
      var isActive = false;
      items.map((item) => {
        if (window.location.pathname === item.link) {
          isActive = true;
        }
      });
      return isActive;
    } else {
      return false;
    }
  };

  const isActiveLink = (link) => {
    console.warn("link : " + link);
    var isActive = false;
    if (window.location.pathname === link) {
      isActive = true;
    }
    return isActive;
  };
  const sidebarMenuContent = (
    <div>
      <PerfectScrollbar>
        <Router>
          <Route
            render={({ location, history }) => (
              <React.Fragment>
                <Box
                  className={
                    darkMode && process.env.REACT_APP_ENVIRONMENT === "USA"
                      ? "USA_SideNav1"
                      : process.env.REACT_APP_ENVIRONMENT === "USA"
                      ? "USA_SideNav"
                      : "Vis_SideNav"
                  }
                >
                  <SideNav
                    id="style-1"
                    style={{
                      backgroundColor: darkMode ? "#0B2E4D" : "#2281AB",
                      position: "fixed",
                      boxShadow: "0px 1px 4px #00000029",
                      width: "68px",
                      // zIndex: "10000",
                      marginTop:
                        decoded_jwtToken.companyType !== "CUSTOMER"
                          ? "50px"
                          : "50px",

                      height: "calc(100vh - 50px - 35px)",
                      // opacity: diaLogBoxBlur ? 0.8 : "",
                      pointerEvents: diaLogBoxBlur ? "none" : "auto",
                    }}
                    expanded={expand || toggle}
                    onSelect={(selected) => {
                      const to = selected;
                      if (
                        location.pathname !== to &&
                        decoded_jwtToken.companyType !== "CUSTOMER" &&
                        to === "Dashboard"
                      ) {
                        history.push("/vis/dashboardPanel");
                      }
                      if (
                        location.pathname !== to &&
                        decoded_jwtToken.companyType === "CUSTOMER" &&
                        to === "Dashboard"
                      ) {
                        history.push("/vis/dashboard");
                      }
                      if (location.pathname !== to && to !== "Dashboard") {
                        history.push(to);
                      }
                    }}
                  >
                    {decoded_jwtToken.companyType !== "CUSTOMER" ? (
                      <Box style={{ height: "17px", width: "100%" }}></Box>
                    ) : (
                      <Box style={{ height: "17px", width: "100%" }}>
                        {/* {toggle ? (
                          <Link href={REACT_URL_DASHBOARD}>
                            <img
                              src={logo_smartgurd}
                              width="100%"
                              height=""
                              alt="mysmartguard"
                            />
                          </Link>
                        ) : (
                          <Link href={REACT_URL_DASHBOARD}>
                            <img
                              src={logo_mbl}
                              width="100%"
                              height=""
                              alt="mysmartguard"
                            />
                          </Link>
                        )} */}
                      </Box>
                    )}
                    <Box></Box>
                    {!paymentmethod && (
                      <SideNav.Nav>
                        {(decoded_jwtToken.roleName === "Employee"
                          ? navItemEmployeelogin
                          : navItems &&
                            process.env.REACT_APP_ENVIRONMENT === "USA" &&
                            decoded_jwtToken.companyType === "NONE" &&
                            decoded_jwtToken.roleCode === "ADMIN"
                          ? navItemDealer
                          : navItems &&
                            process.env.REACT_APP_ENVIRONMENT === "USA" &&
                            decoded_jwtToken.companyType === "PARTNER" &&
                            decoded_jwtToken.roleCode === "ADMIN"
                          ? navItemCustomer
                          : navItems &&
                            process.env.REACT_APP_ENVIRONMENT === "USA" &&
                            decoded_jwtToken.roleName === "Admin"
                          ? filterData
                          : navItems &&
                            process.env.REACT_APP_ENVIRONMENT === "USA" &&
                            decoded_jwtToken.companyType === "NONE"
                          ? navItemDealer
                          : navItems &&
                            process.env.REACT_APP_ENVIRONMENT === "USA" &&
                            decoded_jwtToken.companyType === "PARTNER"
                          ? navItemCustomer
                          : navItems &&
                            process.env.REACT_APP_ENVIRONMENT === "USA" &&
                            decoded_jwtToken.roleName === "Front Desk"
                          ? navItemFrontEnd
                          : navItems &&
                            process.env.REACT_APP_ENVIRONMENT === "USA" &&
                            decoded_jwtToken.roleName === "Owner"
                          ? filterData
                          : navItems
                        ).map((parent, index) => {
                          var eventKey =
                            parent.items && parent.items.length > 0
                              ? parent.id
                              : parent.link;
                          return (
                            <NavItem
                              active={
                                isActiveLink(parent.link) ||
                                activeParent === parent.name
                              }
                              eventKey={parent.name}
                              key={index}
                              className="navItemBg"
                              onClick={() => {
                                if (parent.name === "Dashboard") {
                                  setActiveParent(parent.name);
                                }
                                toggleIcon(parent);
                                toggleExpansion(parent.name);
                              }}
                              onMouseEnter={() => setHoveredItem(parent.name)}
                              onMouseLeave={() => setHoveredItem(null)}
                              style={{ border: "none" }}
                            >
                              <NavIcon
                                sx={{
                                  width: "100px",
                                  // marginRight: "-20px",
                                  justifyContent: "center",
                                }}
                              >
                                {(hoveredItem === parent.name ||
                                  expandedParent === parent.name) &&
                                parent.HoverIcon ? (
                                  <parent.HoverIcon />
                                ) : (
                                  <parent.Icon />
                                )}
                              </NavIcon>
                              {expand || toggle ? (
                                <NavText>
                                  <Box
                                    className="navTextTitle"
                                    component="span"
                                    display="flex"
                                    alignItems="center"
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: 400,
                                    }}
                                  >
                                    {parent.name}{" "}
                                    {!parent.items ? null : (
                                      <>
                                        {expandedParent === parent.name ? (
                                          <KeyboardArrowUpIcon
                                            sx={{
                                              position: "absolute",
                                              fontSize: 20,
                                              right: 15,
                                            }}
                                            onClick={() => {
                                              toggleIcon(!setActive);
                                            }}
                                          />
                                        ) : (
                                          <KeyboardArrowDownIcon
                                            sx={{
                                              position: "absolute",
                                              fontSize: 20,
                                              right: 15,
                                            }}
                                            onClick={() => {
                                              toggleIcon(setActive);
                                            }}
                                          />
                                        )}
                                      </>
                                    )}
                                  </Box>
                                </NavText>
                              ) : null}
                              {parent.items && parent.items.length > 0
                                ? parent.items.map((child, index) => {
                                    return (
                                      <NavItem
                                        key={index}
                                        eventKey={`${child.link}`}
                                        onClick={() => handlenav(child, parent)}
                                      >
                                        <NavText>
                                          <Box
                                            className="navTextSubTitle"
                                            component="span"
                                            display="flex"
                                            alignItems="center"
                                            style={{
                                              marginLeft: "35px",
                                              width: "100%",
                                            }}
                                          >
                                            <ul
                                              style={{
                                                listStyle: "none",
                                                padding: 0,
                                                margin: 0,
                                                width: "100%",
                                              }}
                                            >
                                              <li
                                                style={{
                                                  color:
                                                    location.pathname ===
                                                    child.link
                                                      ? "#F2824C"
                                                      : darkMode
                                                      ? "#fff"
                                                      : "rgb(15, 90, 156)",

                                                  padding: "10px",
                                                  cursor: "pointer",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  width: "100%",
                                                  fontSize: "13px",
                                                  transition: "color 0.3s ease",
                                                  lineHeight: "1.2",
                                                  fontWeight: 400,
                                                  marginLeft:
                                                    expand || toggle
                                                      ? "0px"
                                                      : "-50px",
                                                }}
                                                onMouseEnter={(e) =>
                                                  (e.target.style.color =
                                                    "#F2824C")
                                                }
                                                onMouseLeave={(e) =>
                                                  (e.target.style.color =
                                                    location.pathname ===
                                                    child.link
                                                      ? "#F2824C"
                                                      : darkMode
                                                      ? "#fff"
                                                      : "rgb(15, 90, 156)")
                                                }
                                                onClick={() =>
                                                  handlenav(child, parent)
                                                }
                                              >
                                                {child.name}
                                              </li>
                                            </ul>
                                          </Box>
                                        </NavText>
                                      </NavItem>
                                    );
                                  })
                                : null}
                            </NavItem>
                          );
                        })}
                      </SideNav.Nav>
                    )}

                    <div>
                      <PerfectScrollbar>{perfectSideBar}</PerfectScrollbar>
                      <div
                        // component="div"
                        style={{
                          // width: '100%',
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          position: "fixed",
                          bottom: "11px",
                          height: "6%",
                          width: "40px",

                          width: expand ? "240px" : "68px",

                          backgroundColor: darkMode
                            ? "#0B2E4D"
                            : "rgb(34, 129, 171)",
                          marginBottom: "-10px",
                        }}
                        sx={{ ml: 3.5 }}
                      >
                        <IconButton
                          onClick={handleToggle}
                          style={{ marginLeft: "17px" }}
                        >
                          {expand ? <CollapsIcon /> : <ExpandArrowIcon />}
                          {/* <MenuIcon
                            style={{
                              color:
                                decoded_jwtToken.companyType !== "CUSTOMER"
                                  ? "#fff"
                                  : "#fff",
                            }}
                          /> */}
                        </IconButton>
                      </div>
                      {/* </div> */}
                      {decoded_jwtToken.companyType !== "NONE" &&
                      decoded_jwtToken.partnerType !== "DEALER" ? (
                        <>
                          {bottom === 3.5 || position === 24 ? (
                            <Tooltip
                              title={t("COMMON149")}
                              arrow
                              placement="right-start"
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                position: "fixed",
                                height: "5%",
                                width: "55px",
                                boxShadow: "none",
                                backgroundColor: "transparent",
                                // zIndex: 12000,
                              }}
                              sx={{
                                bottom: bottom,
                                ml: position,
                              }}
                            >
                              <IconButton
                                onMouseEnter={() => setHoveredPin(true)}
                                onMouseLeave={() => setHoveredPin(false)}
                              >
                                <img
                                  alt="..."
                                  // src={darkMode ? CheckInPinDark : CheckInPin}
                                  src={getPinImage()}
                                  onClick={handleOpen}
                                  style={{
                                    width: "40px",
                                    height: "35px",
                                    marginBottom: "10px",
                                    marginRight: "15px",
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                          ) : (
                            <Tooltip
                              title={t("COMMON149")}
                              arrow
                              placement="right-end"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                position: "fixed",
                                height: "6%",
                                width: "80px",
                                boxShadow: "none",
                                marginLeft: "-7px",
                                backgroundColor: "transparent",
                                // zIndex: 12000,
                              }}
                              sx={{
                                bottom: bottom,
                                ml: position,
                              }}
                            >
                              <IconButton
                                onMouseEnter={() => setHoveredPin(true)}
                                onMouseLeave={() => setHoveredPin(false)}
                              >
                                <img
                                  alt="..."
                                  // src={darkMode ? CheckInPinDark : CheckInPin}
                                  src={getPinImage()}
                                  onClick={handleOpen}
                                  style={{ marginTop: "70%", height: "30px" }}
                                />
                              </IconButton>
                            </Tooltip>
                          )}
                          {decoded_jwtToken.companyType === "CUSTOMER" &&
                          decoded_jwtToken.roleName !== "Employee" ? (
                            <>
                              {doorBottom === 3.5 || doorPosition === 17 ? (
                                <Tooltip
                                  title={
                                    <div style={{ marginLeft: "2.75rem" }}>
                                      <span>{t("EMERGENCY_DOOR")}</span>
                                    </div>
                                  }
                                  arrow
                                  placement="right-start"
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    position: "fixed",
                                    height: "5%",
                                    width: "55px",
                                    boxShadow: "none",
                                    backgroundColor: "transparent",
                                    // zIndex: 12000,
                                  }}
                                  sx={{ bottom: doorBottom, ml: doorPosition }}
                                >
                                  <IconButton
                                    onClick={handleOpenDoor}
                                    onMouseEnter={() => setHovered(true)}
                                    onMouseLeave={() => setHovered(false)}
                                  >
                                    <img
                                      alt="..."
                                      src={getImage()}
                                      style={{
                                        width: "40px",
                                        height: "35px",
                                        marginBottom: "10px",
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>
                              ) : (
                                <Tooltip
                                  title={"Emergency Door"}
                                  arrow
                                  placement="right-end"
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    position: "fixed",
                                    height: "55px",
                                    width: "80px",
                                    marginLeft: "-7px",
                                    boxShadow: "none",
                                    backgroundColor: "transparent",
                                  }}
                                  sx={{ bottom: doorBottom, ml: doorPosition }}
                                >
                                  <IconButton
                                    onClick={handleOpenDoor}
                                    onMouseEnter={() => setHovered(true)}
                                    onMouseLeave={() => setHovered(false)}
                                  >
                                    <img
                                      alt="..."
                                      src={getImage()}
                                      style={{
                                        marginTop: "30%",
                                        height: "30px",
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </>
                          ) : null}
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </SideNav>
                </Box>
              </React.Fragment>
            )}
          />
        </Router>
      </PerfectScrollbar>
    </div>
  );

  return (
    <Fragment>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          open={sidebarToggleMobile}
          onClose={closeDrawer}
          variant="temporary"
          elevation={4}
          className="app-sidebar-wrapper-lg"
        >
          <SidebarHeader />
          <PerfectScrollbar options={{ wheelPropagation: true }}>
            {sidebarMenuContent}
          </PerfectScrollbar>
        </Drawer>
      </Hidden>

      <Hidden mdDown>
        <Paper
          className={clsx("app-sidebar-wrapper", {
            "app-sidebar-wrapper-fixed": "",
          })}
          square
          elevation={sidebarShadow ? 11 : 3}
        >
          <SidebarHeader />
          <div className={clsx({ "app-sidebar-menu": "" })}>
            <PerfectScrollbar
              options={{ wheelPropagation: true }}
              onScrollY={(container) =>
                console.log(`scrolled to: ${container.scrollTop}.`)
              }
            >
              {sidebarMenuContent}
            </PerfectScrollbar>
          </div>
        </Paper>
      </Hidden>
      {open && (
        <PinDialogBox
          open={open}
          handleClose={() => {
            setOpen(false);
          }}
        />
      )}
      {openDoor && (
        <EmergencyDoor
          open={openDoor}
          handleClose={() => {
            setOpenDoor(false);
          }}
        />
      )}
    </Fragment>
  );
}

function mapStateToProps(state) {
  return {
    sidebarFixed: state.ThemeOptions.sidebarFixed,
    headerFixed: state.ThemeOptions.headerFixed,
    sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setSidebarToggleMobile: (e) => dispatch(setSidebarToggleMobile(e)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
